// i18m文件夹下新建index.js
import Vue from 'vue'
import Vuei18n from 'vue-i18n'
Vue.use(Vuei18n)
import zh from '../language/zh';
import en from '../language/en';
import viet from '../language/Viet';

const i18n = new Vuei18n({
  locale : localStorage.getItem('lang') || 'zh', // 语言
  messages: {  // 文案
  zh, // 文案的中文版
  en,// 文案的英文版
  viet,//越南文
  }
})
export default i18n
